require('./dist/index').register();
